import styled from 'styled-components';

const InputText = styled.input`
  padding: 0.25rem;
  font-size: 1.2rem;
  background: transparent;
  border: 0;
  width: 100%;
  box-sizing: border-box;
`;

export default InputText;
